import { render, staticRenderFns } from "./registerdata.vue?vue&type=template&id=cfbb142c&"
import script from "./registerdata.vue?vue&type=script&lang=js&"
export * from "./registerdata.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports